export function Brand({ compact = false, inverse = false }: { compact?: boolean; inverse?: boolean }) {
  return (
    <div className={`brand${compact ? " brand--compact" : ""}${inverse ? " brand--inverse" : ""}`} aria-label="Ruta Mágica Operación">
      <span className="brand__mark" aria-hidden="true">
        <img src="/ruta-magica-logo.png" alt="" />
      </span>
      <span className="brand__copy">
        <strong>RUTA MÁGICA</strong>
        <small>OPERACIÓN</small>
      </span>
    </div>
  );
}
